export default __webpack_public_path__ + "static/media/image.c85b4950.png";